import React from 'react'
import { AppProps } from 'next/app'
import { store } from '@/app/store'
import { Provider as ReduxProvider } from 'react-redux'
import 'tailwindcss/tailwind.css'
import '@/styles/globals.scss'
import '@/styles/Common.scss'
import '@/styles/component/Button.scss'
import '@/styles/component/ButtonLink.scss'
import '@/styles/component/Dialog.scss'
import '@/styles/component/Thumbnail.scss'
import '@/styles/component/Form.scss'
import '@/styles/component/Tag.scss'
import '@/styles/component/Detail.scss'
import '@/styles/component/SwiperMap.scss'
import PageView from '@/lib/usePageHooks'
// import { usePageViewAnalytics, GoogleAnalytics } from '@/lib/gtag'

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <ReduxProvider store={store}>
        <PageView />
        <Component {...pageProps} />
      </ReduxProvider>
    </>
  )
}

export default MyApp
